import { all } from 'redux-saga/effects';

import { saga as authSaga } from 'modules/auth';
import { saga as newsSaga } from 'modules/news';
import { saga as filesSaga } from 'modules/uploader';
import { saga as partnersSaga } from 'modules/partners';
import { saga as infoSaga } from 'modules/info';
import { saga as venuesSaga } from 'modules/venues';
import { saga as mapsSaga } from 'modules/maps';
import { saga as importsSaga } from 'modules/imports';

export default function* () {
    yield all([
        authSaga(),
        newsSaga(),
        filesSaga(),
        partnersSaga(),
        infoSaga(),
        venuesSaga(),
        mapsSaga(),
        importsSaga(),
    ]);
}
